import { useCallback, useEffect, useRef, useState } from "react";
import { markStarted } from "@/lib/progress";
import { queueSave } from "@/lib/cloud";

export const useStoredState = (key, initial) => {
  const initialRef = useRef(initial);
  const dirty = useRef(false);
  const [value, setValue] = useState(() => {
    try {
      const s = localStorage.getItem(`sap:${key}`);
      return s ? JSON.parse(s) : initial;
    } catch {
      return initial;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(`sap:${key}`, JSON.stringify(value));
    } catch {
      /* storage full or blocked */
    }
    if (dirty.current) queueSave(key, value);
  }, [key, value]);
  const reset = useCallback(() => {
    dirty.current = true;
    setValue(initialRef.current);
  }, []);
  const set = useCallback((v) => {
    dirty.current = true;
    setValue(v);
    markStarted(key);
  }, [key]);
  return [value, set, reset];
};

export const useActiveSection = (ids) => {
  const [active, setActive] = useState(null);
  useEffect(() => {
    const els = ids.map((id) => document.getElementById(id)).filter(Boolean);
    if (!els.length) return undefined;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px" }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [ids]);
  return active;
};
